// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch{border-radius:0 .372rem .372rem 0!important;height:auto!important}.siwtch-input{border-radius:.372rem 0 0 .372rem!important}.switch .ant-switch-handle:before{border-radius:.372rem!important}.switch .ant-switch-handle{height:90%!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
